import * as actions from 'client/actions/actionsManagement'
import usePresentPage from 'client/hooks/usePresentPage'
import { getPageType } from 'client/reducers/pageReducer'
import { useActions } from 'common/hooks/useActions'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
  useOverlayActionsContext,
  useOverlayVisibilityContext,
} from 'src/editor/layout/sidebar/settings/settings-overlay-context'
import { BackButton } from 'src/editor/shared/components/back-button'
import { Overlay } from 'src/shared/components/overlay'
import { createPageSettings } from './pages'
import SettingsBackUi from './ui/SettingsBackUi'
import SettingsTitleUi from './ui/SettingsTitleUi'

function PageSettings() {
  const { t } = useTranslation()
  const setActiveSidebarTab = useActions(actions.setActiveSidebarTab)
  const pageType = usePresentPage(getPageType)
  const isOverlayVisible = useOverlayVisibilityContext()
  const { close } = useOverlayActionsContext()

  const closePageSettings = useCallback(() => {
    setActiveSidebarTab(null)
  }, [setActiveSidebarTab])

  return (
    <React.Fragment>
      <BackButton onClick={closePageSettings}>
        {t('entity_settings.back_to_page')}
      </BackButton>
      <div className="mt-8">
        {createPageSettings(pageType)}
        {isOverlayVisible && (
          <Overlay hide={close} zIndex="var(--z-index-picker)" dark />
        )}
      </div>
    </React.Fragment>
  )
}

export default PageSettings
